var _defs, _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 360",
    width: 480,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration_404-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 328.8,
    y1: 424,
    x2: 505.4,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0984e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0984e3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 135.3,
    y1: 97.6,
    x2: 182.1,
    y2: 144.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b78103"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { opacity: .2;fill: url(#g1) } \n\t\t.s1 { opacity: .1;fill: #ffc107 } \n\t\t.s2 { fill: url(#g2) } \n\t\t.s3 { fill: #002f54 } \n\t\t.s4 { fill: #0984e3 } \n\t\t.s5 { opacity: .2;fill: #0984e3 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m64.3 67.9c24.7-18.6 55-29.8 87.7-30.3c9.6-11.2 21.4-20.5 34.6-26.9q5.4-2.7 11-4.7q5.6-2 11.3-3.3q5.8-1.4 11.7-2q6-0.7 11.9-0.7c38.9 0 72.9 21.4 91.9 53.6c7.2-1.3 14.6-1.9 22.1-1.9c73.7 0 133.5 62.3 133.5 139.3c0 22.4-5.1 43.6-14.1 62.3c-10.4 21.6-25.9 39.9-44.9 53.3c-21.3 14.9-46.9 23.7-74.5 23.7h-0.1c-8.4 0-16.6 2.8-22.9 8.4c-10.2 9-22.5 15.3-36.1 17.9c-4.8 1-9.7 1.5-14.7 1.5q-4.4 0-8.8-0.5q-4.4-0.5-8.7-1.5q-4.3-1.1-8.4-2.6q-4.1-1.5-8.1-3.4c-8.8-4.4-18.9-4.8-27.9-1.1q-6.7 2.7-13.7 4.8q-6.9 2.1-14 3.4q-7.2 1.4-14.4 2.1q-7.2 0.7-14.4 0.7c-45.6-0.1-86.5-20.7-114.8-53.4c-24.6-28.6-39.5-66.4-39.5-107.8c0-53.9 25.4-101.6 64.3-130.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Layer",
    className: "s1",
    cx: 182.1,
    cy: 97.6,
    r: 44.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Layer",
    className: "s2",
    cx: 182.1,
    cy: 97.6,
    r: 23.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s3",
    d: "m182.3 244c0-34.5 28-62.5 62.6-62.5c34.5 0 62.6 28 62.6 62.5c0 34.6-28.1 62.6-62.6 62.6c-34.6 0-62.6-28-62.6-62.6zm62.6 39.4c21.7 0 39.4-17.6 39.4-39.4c0-21.7-17.7-39.4-39.4-39.4c-21.8 0-39.4 17.7-39.4 39.4c0 21.8 17.6 39.4 39.4 39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s4",
    d: "m175 271.7c0 4.2-1.3 5.7-5.7 5.7h-11.4v21.7c0 4.1-1.5 5.6-5.6 5.6h-8.2c-4.1 0-5.6-1.5-5.6-5.6v-21.7h-54.7c-4.1 0-5.6-1.5-5.6-5.7v-5.9q0-0.9 0.1-1.8q0.1-0.9 0.3-1.8q0.3-0.9 0.7-1.7q0.4-0.8 0.9-1.5l55-68.3q0.7-0.9 1.6-1.7q0.9-0.7 1.9-1.2q1-0.6 2.2-0.8q1.1-0.3 2.2-0.3h9.2c4.2 0 5.7 1.2 5.7 5.7v66.6h11.3c4.2 0 5.7 1.5 5.7 5.6zm-36.5-12.8v-44.4l-36 44.4zm273.1 12.8c0 4.1-1.1 5.6-5.6 5.6h-11.4v21.7c0 4.2-1.5 5.7-5.7 5.7h-8.1c-4.1 0-5.6-1.5-5.6-5.7v-21.7h-54.7c-4.1 0-5.6-1.5-5.6-5.6v-6q-0.1-0.9 0-1.8q0.2-0.9 0.4-1.7q0.3-0.9 0.6-1.7q0.4-0.8 1-1.6l55-68.2q0.7-1 1.6-1.7q0.9-0.8 1.9-1.3q1-0.5 2.1-0.8q1.2-0.2 2.3-0.2h9.1c4.2 0 5.7 1.2 5.7 5.6v66.6h11.4c4.1 0 5.6 1.5 5.6 5.7zm-36.4-12.8v-44.4l-36 44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m425.1 120.1q-0.5 1.4-1.5 2.6q-1 1.1-2.4 1.8q-1.3 0.7-2.8 0.9v0.1h-38.6c-3.1 0.1-6-1-8.2-3.1c-2.2-2.1-3.4-5-3.4-8.1c0-3 1.2-5.9 3.4-8c2.2-2.1 5.1-3.2 8.2-3.1h0.4q-0.5-2-0.4-4q0.1-2 0.8-3.9q0.7-1.9 2-3.4q1.2-1.6 2.9-2.8c2.2-1.5 4.8-2.3 7.5-2.3c2.7 0 5.3 0.8 7.5 2.3c2.2 1.5 3.9 3.7 4.9 6.2c0.9 2.5 1.1 5.3 0.4 7.9h0.4q1.5 0 3 0.4q1.4 0.4 2.7 1.2q1.3 0.8 2.4 1.8q1 1.1 1.7 2.5c1.2-0.2 2.4-0.2 3.6 0.2c1.1 0.3 2.2 0.8 3.1 1.6c0.9 0.8 1.7 1.8 2.2 2.9c0.5 1 0.7 2.2 0.7 3.4q0 1.5-0.5 2.9zm-321.3 81.4q-0.5 1.3-1.3 2.2q-0.9 1-2 1.6q-1.1 0.6-2.4 0.8h-33.2c-2.6 0.1-5.1-0.8-7-2.6c-1.9-1.8-2.9-4.3-2.9-6.9c0-2.6 1-5.1 2.9-6.9c1.9-1.8 4.4-2.8 7-2.7h0.3c-0.8-3.4 0-7 2.1-9.7c2.2-2.8 5.5-4.4 9-4.4c3.4 0 6.8 1.6 8.9 4.4c2.2 2.7 2.9 6.3 2.1 9.7h0.3q1.3 0 2.5 0.4q1.3 0.3 2.4 1q1.1 0.6 2 1.6q0.9 0.9 1.5 2q0.6 0 1.2 0q1.4 0 2.7 0.5q1.3 0.5 2.3 1.5q1 1 1.5 2.3q0.6 1.3 0.6 2.7q0 1.3-0.5 2.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration404);
export default __webpack_public_path__ + "static/media/illustration_404.f8a4848459fd88f9be7c6cdd04e41ccc.svg";
export { ForwardRef as ReactComponent };